import { ReportTypeKey } from './types/report-type-key';
import { GridHeader } from './models/gridHeader';
import { MainFilterItem } from './models/mainFilterItem';
import { REPORT_CONFIG_SELLER_TRUST_INDEX } from './REPORT_CONFIG_SELLER_TRUST_INDEX';
import { REPORT_CONFIG_SELLER_MARKET_SHARE } from './REPORT_CONFIG_SELLER_MARKET_SHARE';
import { REPORT_CONFIG_SELLER_COPPA_INDEX } from './REPORT_CONFIG_SELLER_COPPA_INDEX';
import { REPORT_CONFIG_PUBLISHER_TRUST_INDEX } from './REPORT_CONFIG_PUBLISHER_TRUST_INDEX';
import { REPORT_CONFIG_PUBLISHER_GROSSING } from './REPORT_CONFIG_PUBLISHER_GROSSING';
import { REPORT_CONFIG_PUBLISHER_REACH } from './REPORT_CONFIG_PUBLISHER_REACH';
import { REPORT_CONFIG_PUBLISHER_COPPA } from './REPORT_CONFIG_PUBLISHER_COPPA';
import { REPORT_CONFIG_DEVICE_REACH } from './REPORT_CONFIG_DEVICE_REACH';
import { REPORT_CONFIG_DEVICE_MARKET_SHARE } from './REPORT_CONFIG_DEVICE_MARKET_SHARE';
import { REPORT_CONFIG_HIGH_RISK_MFA } from './REPORT_CONFIG_HIGH_RISK_MFA';

export interface ReportConfig {
  key: ReportTypeKey;
  title: string;
  formTitle?: string;
  heading: string;
  subHeading?: string;
  reportId: string;
  mainFilterItems: MainFilterItem[];
  gridHeaders: GridHeader[];
  permissions: string[];
  defaultSort?: string;
  defaultTitleKey?: string;
  pageTitle?: string;
  pageMeta?: string;
  sortable?: boolean;
  showTitle?: boolean;
  notHideDataIfNA?: boolean;
  rowLimit?: number;
  fadeStart?: number;
  cta?: {
    anonHeading?: string;
    freemiumHeading?: string;
    showAll?: boolean;
  };
}

export const REPORT_CONFIG: ReportConfig[] = [
  REPORT_CONFIG_SELLER_TRUST_INDEX,
  REPORT_CONFIG_SELLER_MARKET_SHARE,
  REPORT_CONFIG_SELLER_COPPA_INDEX,
  REPORT_CONFIG_PUBLISHER_TRUST_INDEX,
  REPORT_CONFIG_PUBLISHER_GROSSING,
  REPORT_CONFIG_PUBLISHER_REACH,
  REPORT_CONFIG_PUBLISHER_COPPA,
  REPORT_CONFIG_DEVICE_REACH,
  REPORT_CONFIG_DEVICE_MARKET_SHARE,
  REPORT_CONFIG_HIGH_RISK_MFA
];
